<template>
  <div class="full-page">
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <img
        :src="imgLogo"
        class="logo"
      />
    </md-toolbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="page-header header-filter backGrndImgPosition"
        :class="{'backGrndImgOmni': tenant !== 'ima' && tenant !== 'ipmc', 'backGrndImgRocket': tenant === 'ima' || tenant === 'ipmc' }"
      >
        <div class="container md-offset">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isTenantMixin from '@/components/mixins/isTenantMixin'

export default {
  data () {
    return {
      imgLogo: '',
      tenant: ''
    }
  },
  mixins: [isTenantMixin],
  created () {
    this.imgLogo = this.tenant === 'ima' || this.tenant === 'ipmc' ? './img/rocketchat-logo.png' : './img/omni-sidebar.png'
  }
}
</script>

<style lang="scss" scoped>

.backGrndImgPosition {
  background-position: center;
  background-size: cover;
}
.backGrndImgOmni {
  background-image: url("../../../../public/img/sidebar-background.jpg");
}

.backGrndImgRocket {
  background-image: url("../../../../public/img/rocketchat-bg.jpeg");
}

.logo {
  height: 50px;
  margin-top: 15px;
  margin-left: 25px;
}

.page-header {
  &::before {
    background-color: transparent;
  }
}
</style>
